import { useEffect } from 'react';

type PageMetaOptions = {
  title: string;
  description: string;
  path?: string;
  image?: string;
};

const SITE_NAME = 'WAOUH';
const DEFAULT_IMAGE = '/assets/waouh-header-logo.svg';

const getMetaTag = (selector: string) => document.querySelector<HTMLMetaElement>(selector);

const setMetaContent = (selector: string, content: string) => {
  const tag = getMetaTag(selector);

  if (tag) {
    tag.setAttribute('content', content);
  }
};

export const usePageMeta = ({ title, description, path, image }: PageMetaOptions) => {
  useEffect(() => {
    const fullTitle = title.trim() === SITE_NAME ? SITE_NAME : `${title} | ${SITE_NAME}`;
    const origin = window.location.origin;
    const url = path ? new URL(path, origin).toString() : window.location.href;
    const ogImage = image ? new URL(image, origin).toString() : new URL(DEFAULT_IMAGE, origin).toString();

    document.title = fullTitle;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', fullTitle);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[property="og:type"]', 'website');
    setMetaContent('meta[property="og:url"]', url);
    setMetaContent('meta[property="og:image"]', ogImage);
    setMetaContent('meta[name="twitter:card"]', 'summary_large_image');
    setMetaContent('meta[name="twitter:title"]', fullTitle);
    setMetaContent('meta[name="twitter:description"]', description);
    setMetaContent('meta[name="twitter:image"]', ogImage);
  }, [description, image, path, title]);
};